import { render, staticRenderFns } from "./VTCWM101Component.vue?vue&type=template&id=423cfa6c&scoped=true&"
import script from "./VTCWM101Component.vue?vue&type=script&lang=js&"
export * from "./VTCWM101Component.vue?vue&type=script&lang=js&"
import style0 from "./VTCWM101Component.vue?vue&type=style&index=0&id=423cfa6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cfa6c",
  null
  
)

export default component.exports